import type { ProductResult } from 'hooks/siteSearch/types';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface ProductProps extends ProductResult {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

export function Product({ title, href, image, onNavigate }: ProductProps) {
  return (
    <ResultLayout
      href={href}
      title={title}
      type="Product"
      image={image}
      onNavigate={() => onNavigate({ title, path: href })}
    />
  );
}
